export const settings = [
  {
    label: "Content background",
    type: "background-color",
    selector: "content",
    value: "#FB6068"
  },
  {
    label: "Form background",
    type: "background-color",
    selector: "form",
    value: "#fff"
  },
  {
    label: "Border radius",
    type: "border-radius",
    selector: "form",
    value: 8
  },
  {
    label: "Background image",
    type: "background-image",
    selector: "background",
    value: "url(//pages.convertkit.com/assets/powell/bg.jpg)"
  },
  {
    label: "Background transparency",
    type: "opacity",
    selector: "background",
    value: "0.2"
  },

  {
    group: "header",
    type: "color",
    selector: "header",
    value: "#fff"
  },
  {
    group: "header",
    type: "font-size",
    selector: "header",
    value: 22
  },
  {
    group: "header",
    type: "font-weight",
    selector: "header",
    value: 700
  },

  {
    group: "subheader",
    type: "color",
    selector: "subheader",
    value: "#7D7D7D"
  },
  {
    group: "subheader",
    type: "font-size",
    selector: "subheader",
    value: 16
  },

  {
    group: "field",
    type: "color",
    selector: "field",
    value: "#4D4D4D"
  },
  {
    group: "field",
    type: "border-color",
    selector: "field",
    value: "#e3e3e3"
  },
  {
    group: "field",
    type: "border-radius",
    selector: "field",
    value: 4
  },
  {
    group: "field",
    type: "font-weight",
    selector: "field",
    value: 400
  },
  {
    group: "button",
    type: "color",
    selector: "button",
    value: "#ffffff"
  },
  {
    group: "button",
    type: "background-color",
    selector: "button",
    value: "#FB6068"
  },
  {
    group: "button",
    type: "border-radius",
    selector: "button",
    value: 24
  },
  {
    group: "button",
    type: "font-weight",
    selector: "button",
    value: 700
  },
  {
    group: "guarantee",
    type: "color",
    selector: "guarantee",
    value: "#7D7D7D"
  },
  {
    group: "guarantee",
    type: "font-size",
    selector: "guarantee",
    value: 13
  },
  {
    group: "guarantee",
    type: "font-weight",
    selector: "guarantee",
    value: 400
  }
]
